import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {WelcomePageActionsEnum} from '@core/enums/welcome-page-actions.enum';

@Component({
    selector: 'app-display-welcome-page',
    templateUrl: './display-welcome-page.component.html',
    styleUrls: ['./display-welcome-page.component.scss']
})
export class DisplayWelcomePageComponent implements AfterViewInit, OnInit {
    @ViewChild('parentElement') parentElement: ElementRef | undefined;
    @Input() disableResume: boolean | undefined;
    @Input() isAdmin = false;
    @Input() isDoctor = false;
    @Input() isPatient = false;
    @Input() isEditor = false;
    @Input() isSuperAdmin = false;
    @Input() hasConsumedConsents = false;
    @Input() isAudioMode: boolean;
    @Input() moreThan3Tiles: boolean;
    @Output() nextStepEvent: EventEmitter<WelcomePageActionsEnum> = new EventEmitter();

    startNewConsentEnum = WelcomePageActionsEnum.NEW_CONSENT;
    viewSubmittedConsentEnum = WelcomePageActionsEnum.VIEW_CONSENTS;
    resumeConsentEnum = WelcomePageActionsEnum.RESUME_CONSENT;
    userManagementEnum = WelcomePageActionsEnum.USER_MANAGEMENT;
    exportDataEnum = WelcomePageActionsEnum.EXPORT_DATA;
    settingsEnum = WelcomePageActionsEnum.SETTINGS;
    medicationEnum = WelcomePageActionsEnum.MEDICATION_MANAGEMENT;
    cmsIndicationsEnum = WelcomePageActionsEnum.CMS_INDICATIONS;
    cmsImagesEnum = WelcomePageActionsEnum.CMS_IMAGES;
    orgManagement = WelcomePageActionsEnum.ORGANIZATION_MANAGEMENT;
    innerWidth: number;

    constructor(private renderer: Renderer2) {
    }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
    }

    nextStepClick(action: WelcomePageActionsEnum): void {
        this.nextStepEvent.emit(action);
    }

    userRoleCssClass(): any {
        if (this.isAdmin && this.isDoctor && this.isPatient) {
            return 'admin-doctor-patient-role';
        } else if (this.isDoctor && this.isPatient) {
            return 'doctor-patient-role';
        }
        return '';
    }

    showGridColumns(): any {
        return 'two-column-layout';
    }

    ngAfterViewInit(): void {
        this.innerWidth = window.innerWidth;
        const tileElement = this.parentElement?.nativeElement.querySelectorAll('app-tile');
        if (tileElement.length === 3) {
            this.renderer.addClass(this.parentElement?.nativeElement, 'three-column-layout');
            this.renderer.removeClass(this.parentElement?.nativeElement, 'two-column-layout');
        }
        else if (this.innerWidth >= 990 && tileElement.length > 3) {
            setTimeout(() => {
                this.moreThan3Tiles = true;
            }, 0);
            this.renderer.addClass(this.parentElement?.nativeElement, 'two-column-layout');
            this.renderer.removeClass(this.parentElement?.nativeElement, 'three-column-layout');
        }
    }
}
